import { Link, useParams } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { MdxBody } from "@/components/MdxBody";
import { bookJsonLd } from "@/lib/seo";
import { bySlug, publications } from "@/lib/content/load";
import { site } from "@/config/site";
import { headingText } from "@/lib/heading";
import { NotFoundPage } from "./NotFoundPage";

export function PublicationDetailPage() {
  const { slug = "" } = useParams();
  const record = bySlug(publications, slug);
  if (!record) return <NotFoundPage />;
  const { meta, Component } = record;
  const jsonLd =
    meta.type === "book"
      ? bookJsonLd(
          meta.title,
          `${site.origin}${meta.canonicalPath}`,
          meta.originalPublishedAt,
        )
      : undefined;

  return (
    <>
      <Seo
        title={meta.title}
        description={meta.seoDescription}
        path={meta.canonicalPath}
        jsonLd={jsonLd}
      />
      <article className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">{meta.type}</p>
        <h1>{headingText(meta.title)}</h1>
        <MdxBody Component={Component} />
        <p>
          <Link to="/resources">All resources</Link>
        </p>
      </article>
    </>
  );
}
